import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    IconButton,
    Grid,
    TextField
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { WelcomeBoardIceBreaker, WelcomeBoardService } from '../../../common/interfaces';
import { ServicesSection } from '../ServicesSection/ServicesSection';

interface ContentSettingsTabProps {
    iceBreakers: WelcomeBoardIceBreaker[];
    services: WelcomeBoardService[];
    onAddIceBreaker: () => void;
    onRemoveIceBreaker: (index: number) => void;
    onUpdateIceBreaker: (index: number, field: keyof WelcomeBoardIceBreaker, value: string) => void;
    onServicesChange: (services: WelcomeBoardService[]) => void;
    clientId: string;
}

export const ContentSettingsTab: React.FC<ContentSettingsTabProps> = ({
    iceBreakers,
    services,
    onAddIceBreaker,
    onRemoveIceBreaker,
    onUpdateIceBreaker,
    onServicesChange,
    clientId
}) => {
    return (
        <Box>
            {/* Ice Breakers */}
            {/* Note: The ice breaker section is currently commented out as it's not being used. Uncomment to enable. */}
            {/* <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">
                            Ice Breaker Questions
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={onAddIceBreaker}
                        >
                            Add Ice Breaker
                        </Button>
                    </Box>

                    {iceBreakers.map((iceBreaker, index) => (
                        <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle1">
                                    Ice Breaker {index + 1}
                                </Typography>
                                <IconButton
                                    color="error"
                                    onClick={() => onRemoveIceBreaker(index)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Title"
                                        value={iceBreaker.title || ''}
                                        onChange={(e) => onUpdateIceBreaker(index, 'title', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Body"
                                        value={iceBreaker.body || ''}
                                        onChange={(e) => onUpdateIceBreaker(index, 'body', e.target.value)}
                                        multiline
                                        rows={3}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}

                    {iceBreakers.length === 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                            No ice breakers added yet. Click "Add Ice Breaker" to get started.
                        </Typography>
                    )}
                </CardContent>
            </Card> */}

            {/* Services */}
            <ServicesSection
                services={services}
                onServicesChange={onServicesChange}
                clientId={clientId}
            />
        </Box>
    );
};
